import React from 'react';

import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

const { PUBLIC_URL } = process.env

function Footer(props) {
  return (
    <>
      <footer className="page-footer font-small mt-5">
        <Container fluid className="text-center">
          <Row noGutters>
            <Col>
            <a href={`${PUBLIC_URL}/mfkey32v2.js`}>mfkey32v2</a>
            </Col>
            <Col>
              © 2021 Eric Betts
            </Col>
            <Col>
            Theme by https://bootswatch.com/
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
}

export default Footer;
